var render = function render(){var _vm=this,_c=_vm._self._c;return (
        [_vm.orderProcess.STEPS.CONFIGURE_MODEL].includes(
            _vm.currentOrderProcessStep
        )
    )?_c('div',{staticClass:"message print-quality-info",class:[
        _vm.backgroundClass,
        { 'is-invisible': typeof _vm.currentCartItem.scale !== 'number' },
    ],attrs:{"id":"print-quality-info"}},[_c('div',{staticClass:"message-body"},[(_vm.printQualityMessage)?[_c('strong',{staticClass:"is-size-5"},[_c('SvgIcon',{staticClass:"mr-3",class:_vm.backgroundClass,attrs:{"icon":_vm.messageIcon}}),_vm._v(" "+_vm._s(_vm.printQualityMessage.messageHeader))],1),_c('p',{domProps:{"innerHTML":_vm._s(_vm.printQualityMessage.messageBody)}})]:[_c('strong',{staticClass:"is-size-5"},[_vm._v(" "+_vm._s(_vm.$t( 'checkout.analysis.printQualityInfo.printabilityIsBeingCalculated' ))+" ")]),_c('b-skeleton',{attrs:{"width":"250"}}),_c('b-skeleton',{attrs:{"width":"350"}})]],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }